/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AuthDto from '../model/AuthDto';
import AuthRequestDto from '../model/AuthRequestDto';
import ErrorDto from '../model/ErrorDto';
import ErrorResponse from '../model/ErrorResponse';
import PaginatedUsersDto from '../model/PaginatedUsersDto';
import PasswordRestoreInputDto from '../model/PasswordRestoreInputDto';
import RefreshTokenDto from '../model/RefreshTokenDto';
import RefreshTokenRequestDto from '../model/RefreshTokenRequestDto';
import RestorePasswordDto from '../model/RestorePasswordDto';
import TokenVerificationDto from '../model/TokenVerificationDto';
import UserDto from '../model/UserDto';
import UserInputDto from '../model/UserInputDto';
import UserValidationDto from '../model/UserValidationDto';

/**
* User service.
* @module api/UserApi
* @version v0
*/
export default class UserApi {

    /**
    * Constructs a new UserApi. 
    * @alias module:api/UserApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the auth operation.
     * @callback module:api/UserApi~authCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuthDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Genera un token JWT para un usuario registrado y devuelve la información del mismo.
     * @param {module:model/AuthRequestDto} authRequestDto 
     * @param {module:api/UserApi~authCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuthDto}
     */
    auth(authRequestDto, callback) {
      let postBody = authRequestDto;
      // verify the required parameter 'authRequestDto' is set
      if (authRequestDto === undefined || authRequestDto === null) {
        throw new Error("Missing the required parameter 'authRequestDto' when calling auth");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AuthDto;
      return this.apiClient.callApi(
        '/api/public/auth', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createUser operation.
     * @callback module:api/UserApi~createUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new user
     * @param {module:model/UserInputDto} userInputDto 
     * @param {module:api/UserApi~createUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserDto}
     */
    createUser(userInputDto, callback) {
      let postBody = userInputDto;
      // verify the required parameter 'userInputDto' is set
      if (userInputDto === undefined || userInputDto === null) {
        throw new Error("Missing the required parameter 'userInputDto' when calling createUser");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = UserDto;
      return this.apiClient.callApi(
        '/api/private/user', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteUserById operation.
     * @callback module:api/UserApi~deleteUserByIdCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a user by ID
     * @param {Number} id ID of the user to delete
     * @param {module:api/UserApi~deleteUserByIdCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteUserById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteUserById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/user/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getUserById operation.
     * @callback module:api/UserApi~getUserByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a user by ID
     * @param {Number} id ID of the user to update
     * @param {module:api/UserApi~getUserByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserDto}
     */
    getUserById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getUserById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = UserDto;
      return this.apiClient.callApi(
        '/api/private/user/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getUserByToken operation.
     * @callback module:api/UserApi~getUserByTokenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get user by token.
     * @param {String} token User token
     * @param {module:api/UserApi~getUserByTokenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserDto}
     */
    getUserByToken(token, callback) {
      let postBody = null;
      // verify the required parameter 'token' is set
      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling getUserByToken");
      }

      let pathParams = {
        'token': token
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = UserDto;
      return this.apiClient.callApi(
        '/api/private/user/token/{token}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getUsers operation.
     * @callback module:api/UserApi~getUsersCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedUsersDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all users
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page number
     * @param {Number} opts.limit Number of items per page
     * @param {module:api/UserApi~getUsersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedUsersDto}
     */
    getUsers(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'limit': opts['limit']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PaginatedUsersDto;
      return this.apiClient.callApi(
        '/api/private/user', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the logout operation.
     * @callback module:api/UserApi~logoutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Cierra la sesion invalidando los tokens de usuario
     * @param {module:api/UserApi~logoutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    logout(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/public/auth', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the refreshToken operation.
     * @callback module:api/UserApi~refreshTokenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RefreshTokenDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Regenera un token JWT para un usuario registrado apartir del un refresh token.
     * @param {module:model/RefreshTokenRequestDto} refreshTokenRequestDto 
     * @param {module:api/UserApi~refreshTokenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RefreshTokenDto}
     */
    refreshToken(refreshTokenRequestDto, callback) {
      let postBody = refreshTokenRequestDto;
      // verify the required parameter 'refreshTokenRequestDto' is set
      if (refreshTokenRequestDto === undefined || refreshTokenRequestDto === null) {
        throw new Error("Missing the required parameter 'refreshTokenRequestDto' when calling refreshToken");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = RefreshTokenDto;
      return this.apiClient.callApi(
        '/api/public/token/refresh', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the register operation.
     * @callback module:api/UserApi~registerCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Crea un usuario y un token de registro a su vez que lo envia por mail.
     * @param {module:model/UserInputDto} userInputDto 
     * @param {module:api/UserApi~registerCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserDto}
     */
    register(userInputDto, callback) {
      let postBody = userInputDto;
      // verify the required parameter 'userInputDto' is set
      if (userInputDto === undefined || userInputDto === null) {
        throw new Error("Missing the required parameter 'userInputDto' when calling register");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = UserDto;
      return this.apiClient.callApi(
        '/api/public/register', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the resendValidationMail operation.
     * @callback module:api/UserApi~resendValidationMailCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserValidationDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Resend validation email by token.
     * @param {String} token User validation token.
     * @param {module:api/UserApi~resendValidationMailCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserValidationDto}
     */
    resendValidationMail(token, callback) {
      let postBody = null;
      // verify the required parameter 'token' is set
      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling resendValidationMail");
      }

      let pathParams = {
        'token': token
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = UserValidationDto;
      return this.apiClient.callApi(
        '/api/public/user/resend-validation-mail/{token}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the restorePassword operation.
     * @callback module:api/UserApi~restorePasswordCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestorePasswordDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Restore user password.
     * @param {module:model/PasswordRestoreInputDto} passwordRestoreInputDto 
     * @param {module:api/UserApi~restorePasswordCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RestorePasswordDto}
     */
    restorePassword(passwordRestoreInputDto, callback) {
      let postBody = passwordRestoreInputDto;
      // verify the required parameter 'passwordRestoreInputDto' is set
      if (passwordRestoreInputDto === undefined || passwordRestoreInputDto === null) {
        throw new Error("Missing the required parameter 'passwordRestoreInputDto' when calling restorePassword");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = RestorePasswordDto;
      return this.apiClient.callApi(
        '/api/public/user/restore-password', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the sendRestore operation.
     * @callback module:api/UserApi~sendRestoreCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestorePasswordDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Restore user password.
     * @param {Object} opts Optional parameters
     * @param {String} opts.username User to who send restore pass mail.
     * @param {String} opts.email Email to who send restore pass mail.
     * @param {module:api/UserApi~sendRestoreCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RestorePasswordDto}
     */
    sendRestore(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'username': opts['username'],
        'email': opts['email']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = RestorePasswordDto;
      return this.apiClient.callApi(
        '/api/public/user/send-restore', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateUserById operation.
     * @callback module:api/UserApi~updateUserByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing user
     * Update an existing user by ID
     * @param {Number} id ID of the user to update
     * @param {module:model/UserDto} userDto 
     * @param {module:api/UserApi~updateUserByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserDto}
     */
    updateUserById(id, userDto, callback) {
      let postBody = userDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateUserById");
      }
      // verify the required parameter 'userDto' is set
      if (userDto === undefined || userDto === null) {
        throw new Error("Missing the required parameter 'userDto' when calling updateUserById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = UserDto;
      return this.apiClient.callApi(
        '/api/private/user/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the validateUser operation.
     * @callback module:api/UserApi~validateUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserValidationDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Validate user by token.
     * @param {String} token User validation token.
     * @param {module:api/UserApi~validateUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserValidationDto}
     */
    validateUser(token, callback) {
      let postBody = null;
      // verify the required parameter 'token' is set
      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling validateUser");
      }

      let pathParams = {
        'token': token
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = UserValidationDto;
      return this.apiClient.callApi(
        '/api/public/user/validate/{token}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the verifyToken operation.
     * @callback module:api/UserApi~verifyTokenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TokenVerificationDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Verifica si el token de acceso actual es válido
     * @param {module:api/UserApi~verifyTokenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TokenVerificationDto}
     */
    verifyToken(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = TokenVerificationDto;
      return this.apiClient.callApi(
        '/api/public/auth/verify', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
